import {store} from "@/store/index.ts";

export const useDataStore = defineStore({
    id: 'data',
    state: () => ({
        data: {},
        channelCode: 'gzsq_001',
        inviteCode: ''
    }),
    getters: {
        getData(): any {
            return this.data;
        },
        getChannelCode(): any {
            return this.channelCode
        },
        getInviteCode(): any {
            return this.inviteCode
        }
    },
    actions: {
        setData(data: any) {
            this.data = data
        },
        setChannelCode(data: any) {
            this.channelCode = data
        },
        setInviteCode(data: any) {
            this.inviteCode = data
        }
    },
    persist: true,
})

export function useDataStoreWithOut() {
    return useDataStore(store);
}
